export const PAYMENT_CANCELLED_CODES = new Set([
  'APPLE_PAY_CANCELLED',
  'GOOGLE_PAY_CANCELLED',
]);

export function isPaymentCancelled(errorCode: string | undefined): boolean {
  return !!errorCode && PAYMENT_CANCELLED_CODES.has(errorCode);
}
